<template>
	<div class="imgWrapper">
		<img :src="imgSrc" alt />
	</div>
</template>

<script>
import constants from '@/api';
// import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { setTimeout, clearTimeout } from 'timers';
import axios from 'axios';
export default {
	created() {},
	components: {},
	data() {
		return {
			imgSrc: '',
		};
	},
	methods: {},
	computed: {},
	mounted() {
		const CancelToken = axios.CancelToken;
		let cancel, timeout;
		try {
			axios({
				method: 'get',
				headers: {
					Authorization: this.$store.getters.authToken,
				},
				url:
					constants.UTILITY_OG_FILE +
					'?uuid=' +
					this.selectedFile.originalFilename.split('.')[0],
				responseType: 'arraybuffer',
				cancelToken: new CancelToken(function(c) {
					cancel = c;
					// console.log(c);
				}),
			})
				.then(res => {
					clearTimeout(timeout);
					var arrayBufferView = new Uint8Array(res.data);
					var blob = new Blob([arrayBufferView], {
						type: 'image/jpeg',
					});
					var urlCreator = window.URL || window.webkitURL;
					var imageUrl = urlCreator.createObjectURL(blob);
					this.imgSrc = imageUrl;
				})
				.catch(e => {
					console.log('Get original image error', e);
				});
			timeout = setTimeout(() => {
				cancel();
			}, 7000);
		} catch (e) {
			console.log('Get original image error', e);
		}
	},
	props: ['selectedFile'],
};
</script>

<style lang="scss" scoped>
.imgWrapper {
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: center;
	img {
		max-width: 100%;
	}
}
</style>
